import React from "react";
import { Lock } from "@mui/icons-material";

import { selectVersionsByProjectId } from "fond/api";
import { Project } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";
import { Actions, permissionCheck } from "fond/utils/permissions";
import { NonIdealState } from "fond/widgets";

import DesignPanel from "./DesignPanel";
import ScenarioPanel from "./ScenarioPanel";

interface CostToServePanelProps {
  // The project currently being viewed / edited
  project: Project;

  // Flag indicating if the project is read only
  readOnly: boolean;
}

const CostToServePanel: React.FC<CostToServePanelProps> = ({ project, readOnly }: CostToServePanelProps) => {
  const versionId = useAppSelector((state) => state.project.versionId);
  const versions = useAppSelector((state) => selectVersionsByProjectId(state, project.ID));

  const originalVersion = versions?.at(-1);
  if (!originalVersion) return null;

  if (!permissionCheck(project.Permission?.Level, Actions.PROJECT_EDIT)) {
    return <NonIdealState size="small" icon={<Lock />} title="View only access" description="You only have view access to this project" />;
  }

  return versionId === originalVersion.ID ? <DesignPanel project={project} readOnly={readOnly} /> : <ScenarioPanel project={project} />;
};

export default CostToServePanel;
